export default __webpack_public_path__ + "static/media/JM.cac0ce05.svg";